import React from "react";
import Layout from "../../shared/components/layout";

function P2pCallback() {
  // comes here with a code and make call for user information,
  // redirected to external payer redirect page when successful
  return (
    <Layout>
      <div>p2p callback here</div>
    </Layout>
  );
}

export default P2pCallback;
